import { COLUMN_ACTION_TYPE, COLUMN_DATE_TIME, COLUMN_OPERATOR, COLUMN_DETAILS, COLUMN_FIELD } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const NotificationAuditColumns: TableColumn[] = [
    {
        heading: "Date/Time",
        accessor: "dateTime",
        isNumeric: false,
        id: 0,
        sortByName: "dateTimeLocal",
        sortDirection: "asc",
        active: true,
        translationKey: "dateTime",
        columnId: COLUMN_DATE_TIME,
    },
    {
        heading: "Operator",
        accessor: "operator",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "operator",
        columnId: COLUMN_OPERATOR
    },
    {
        heading: "Action",
        accessor: "action",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "action",
        columnId: COLUMN_ACTION_TYPE
    },
    // {
    //     heading: "Field",
    //     accessor: "field",
    //     isNumeric: false,
    //     id: 4,
    //     active: true,
    //     translationKey: "field",
    //     columnId: COLUMN_FIELD
    // },
    // {
    //     heading: "Before",
    //     accessor: "valueOld",
    //     isNumeric: false,
    //     id: 3,
    //     active: true,
    //     translationKey: "before",
    //     columnId: COLUMN_DETAILS
    // },
    // {
    //     heading: "After",
    //     accessor: "valueNew",
    //     isNumeric: false,
    //     id: 4,
    //     active: true,
    //     translationKey: "after",
    //     columnId: COLUMN_DETAILS
    // } // These will come in once we support interpreting the field changes for notifications
]

export default NotificationAuditColumns;